import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CountdownConfig, CountdownEvent } from "ngx-countdown";
import { ToastrService } from "ngx-toastr";

import { ApsServiceService } from "../aps-service.service";

const KEY = "time";
const DEFAULT = 10;


@Component({
  selector: "app-resetpassword",
  templateUrl: "./resetpassword.component.html",
  styleUrls: ["./resetpassword.component.css"],
})
export class ResetpasswordComponent implements OnInit {
  loaderdata:any=false
  username:any=''
  requesttoken:any=false
  resetitem:boolean=true
  getuserdata:boolean=true
  generateOTP:boolean=false
  resetpasswordForm:boolean=false
  userid:any=false
  pusherror:boolean=false
  errormessage:any='';
  config: CountdownConfig = { leftTime: DEFAULT,  demand: false ,format: 'm:s' };
  timeLeft: number = 180;
  interval;
  constructor(private router: Router ,private searchitem: ApsServiceService,private toastr: ToastrService,) {}

  ngOnInit(): void {
   
    let value = +localStorage.getItem(KEY)!! ?? DEFAULT;
    if (value <= 0) value = DEFAULT;
    this.config = { ...this.config, leftTime: value };
  }
  iffunction(){
    alert("clicked")
  }
  handleEvent(ev: CountdownEvent) {
    if (ev.action === "notify") {
      // Save current value
      //console.log(ev);
      localStorage.setItem(KEY, `${ev.left / 1000}`);
      if(ev.left == 0){
        alert('0')
        document.getElementById('tokenbtn').setAttribute("disabled","disabled");
      }
      
    }
  }
  closenotif(){
    this.errormessage='';
    this.pusherror=false
  }
  OnUserGet(data){
    this.errormessage='';
    this.pusherror=false
    //console.log(data)
    if(!data.username || data.username == ''){
      this.toastr.warning("Please enter your Username")

       
    }else{
      this.searchitem.CheckUseremail(data.username).subscribe((responce) => {
        this.loaderdata=true
        if(!responce.status){
          this.username="";
          this.username=data.username
          this.searchitem.resetPassword(data.username).subscribe((responce)=>{
            //console.log(responce)
            if(responce.status){
              this.generateOTP =true
              this.getuserdata=false
              this.resetpasswordForm=false
              this.loaderdata=false
              localStorage.setItem('username',responce.username)
              this.toastr.success("OTP is sent to Your Email");
              this.resetOtps()

            }else{
            this.loaderdata=false
            this.toastr.error('please try again','error')
            }
          })
        
    }else{
      this.loaderdata=false
      this.toastr.error("Please Try again"," The User Name does not exist. ")
         }

  })
}

}




getUserOtp(data){
  //console.log(data)
  this.errormessage='';
  this.pusherror=false
  //console.log(data)

  if(!data.otp || data.otp == ''){
    this.toastr.warning("Please Enter Otp")

    this.pusherror=true;

  }else{
    
   let username= localStorage.getItem('username')
    this.searchitem.setOtp(username,data.otp).subscribe((responce)=>{
      //console.log(responce)
      if(responce.status){
        this.generateOTP =false
        this.getuserdata=false
        this.resetpasswordForm=true
        localStorage.setItem('resetuserid',responce.userid)
      }else{
        this.toastr.error('Oops..! Sumting Error. Try next Time');
      }
      this.loaderdata=false
    })

  }

}

changepassword(data){
  //console.log(data)
  //console.log(data)
  this.errormessage='';
  this.pusherror=false
  //console.log(data)

  if(!data.confirm_password || data.confirm_password == '' || !data.password || data.password == ''){
    
    this.toastr.warning("Enter New Password")

  }else{
    if( data.confirm_password == data.password ){
      let userid= localStorage.getItem('resetuserid')
      this.searchitem.ChangePassword(data.password,userid).subscribe((responce)=>{
        if(responce.status){
          this.toastr.success('Password has been changed successfully!');
           this.router.navigate(['/']).then(() => {
          window.location.reload();
        });

        }else{
          this.toastr.error('Oops..! Sumting Error. Try next Time');
          this.router.navigate(['/']).then(() => {
         window.location.reload();
          })
        }
       

      })
    }else{
     
      this.toastr.error("Please try again...","Password did not match")
    }
  }


}
// deleteresertoken
deletetoken(){
  this.searchitem.deleteresertoken(this.userid).subscribe((responce)=>{
    if(responce.status){
      alert('Password has been changed successfully!');
       this.router.navigate(['/']).then(() => {
      window.location.reload();
    });

    }else{
      alert('Oops..! Sumting Error. Try next Time');
      this.router.navigate(['/']).then(() => {
     window.location.reload();
      })
    }
   

  })
}


getusertoken(){  
  this.loaderdata=true
  this.searchitem.resetPassword(this.username).subscribe((responce)=>{
    //console.log(responce)
    if(responce.status){
      this.generateOTP =true
      this.getuserdata=false
      this.resetpasswordForm=false
      this.loaderdata=false
      this.timeLeft = 180;
      this.requesttoken=false
      localStorage.setItem('username',responce.username)
      this.toastr.success("OTP is sent to Your Email");
      this.resetOtps()

    }else{
    this.loaderdata=false
    this.toastr.error('please try again','error')
    }
  })
}




resetOtps(){
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      } else {
      this.pauseTimer() ;
      this.requesttoken=true
      // this.timeLeft = 60;
    }
  },1000)

}

pauseTimer() {
  clearInterval(this.interval);
}




}
